"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSeverityName = void 0;
const parseSeverityName = (severityName) => {
    return severityName.toLowerCase().replace("severity", "").trim();
};
exports.parseSeverityName = parseSeverityName;
